var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <section id=\"shoppingbasket-popup\"> <span id=\"closeshoppingbasket\" class=\"close\" ng-click=\"$ctrl.closeModal()\">&times; </span> <div class=\"container-fluid\">  <div class=\"transclude-target\"></div> </div> </section> </web-component>";
var id1="winresShoppingCartModalPopup.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresShoppingCartModal/winresShoppingCartModalPopup.html
// module id = 511
// module chunks = 2